/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import React from 'react';
import { Select, MenuItem, Checkbox, ListItemText, SelectChangeEvent } from '@mui/material';

interface ISelectFieldProps {
  data: Record<string, any>[];
  onChange: (newValue: any) => void;
  value: any;
}

interface ISelectFieldState {
  selectFieldData: string[];
}

export class MultiSelectField extends React.Component<ISelectFieldProps> {
  public state: ISelectFieldState = {
    selectFieldData: (this.props.value && this.props.value.map((element: any) => element.name)) || [],
  };

  handleChange = (event: SelectChangeEvent<string[]>) => {
    const { data, onChange } = this.props;
    const eventData = event.target.value;
    this.setState({ selectFieldData: eventData });
    const selectedData = data.filter((item) => eventData.includes(item.name));

    onChange(selectedData);
  };

  render() {
    const { data, value } = this.props;
    const { selectFieldData } = this.state;
    let initialData: string[] = [];
    if (value) {
      initialData = value.map((item: Record<string, any>) => item.name);
    }

    return (
      <Select
        color="primary"
        variant="filled"
        multiple
        value={initialData}
        onChange={this.handleChange}
        renderValue={(selected) => (selected as string[]).join(', ')}
      >
        {data.map((item) => (
          <MenuItem key={item.name} value={item.name}>
            <Checkbox color="primary" checked={selectFieldData.indexOf(item.name) > -1} />
            <ListItemText primary={item.name} />
          </MenuItem>
        ))}
      </Select>
    );
  }
}
